function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { registerAction, unregisterAction } from 'helpers/reducerTools';
import * as actionTypes from './actionTypes';
const initialState = {
    account: null,
    client: null,
    fetching: [],
    sending: [],
    errors: [],
    clientId: null
};
export default function reducer(state = _object_spread({}, initialState), action = {}) {
    switch(action.type){
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.INITIALIZE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.INITIALIZE),
                    errors: unregisterAction(state.errors, actionTypes.INITIALIZE)
                });
            }
        case actionTypes.INITIALIZE_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.INITIALIZE)
                });
            }
        case actionTypes.INITIALIZE_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.INITIALIZE),
                    errors: registerAction(state.errors, actionTypes.INITIALIZE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_ACCOUNT:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_ACCOUNT),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_ACCOUNT)
                });
            }
        case actionTypes.FETCH_ACCOUNT_SUCCESS:
            {
                const { account } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    account,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_ACCOUNT)
                });
            }
        case actionTypes.FETCH_ACCOUNT_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    account: null,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_ACCOUNT),
                    errors: registerAction(state.errors, actionTypes.FETCH_ACCOUNT)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_CLIENT:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_CLIENT),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_CLIENT)
                });
            }
        case actionTypes.FETCH_CLIENT_SUCCESS:
            {
                const { client } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    client,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_CLIENT)
                });
            }
        case actionTypes.FETCH_CLIENT_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    client: null,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_CLIENT),
                    errors: registerAction(state.errors, actionTypes.FETCH_CLIENT)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.ACCEPT_CONSENTS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.ACCEPT_CONSENTS),
                    errors: unregisterAction(state.errors, actionTypes.ACCEPT_CONSENTS)
                });
            }
        case actionTypes.ACCEPT_CONSENTS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.ACCEPT_CONSENTS),
                    errors: unregisterAction(state.errors, actionTypes.ACCEPT_CONSENTS)
                });
            }
        case actionTypes.ACCEPT_CONSENTS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.ACCEPT_CONSENTS),
                    errors: registerAction(state.errors, actionTypes.ACCEPT_CONSENTS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.REJECT_CONSENTS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.REJECT_CONSENTS),
                    errors: unregisterAction(state.errors, actionTypes.REJECT_CONSENTS)
                });
            }
        case actionTypes.REJECT_CONSENTS_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.REJECT_CONSENTS),
                    errors: unregisterAction(state.errors, actionTypes.REJECT_CONSENTS)
                });
            }
        case actionTypes.REJECT_CONSENTS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.REJECT_CONSENTS),
                    errors: registerAction(state.errors, actionTypes.REJECT_CONSENTS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.SET_CLIENT_ID:
            {
                const { clientId } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    clientId
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        default:
            {
                return state;
            }
    }
}
